import { Box, IoDocumentText, Typography } from '@bymason-private/legacy-pattern-components';
import { GUIDE_LINKS } from './data';

export default function GuideLinks() {
  return (
    <Box
      sx={{
        flexDirection: 'column',
        display: 'flex',
        gap: 1.5,
        mt: 4,
        minWidth: 200,
        height: 500,
        borderLeft: 0.5,
        pl: 3,
        borderColor: 'lightGray',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IoDocumentText />
        <Typography variant='h6' color='black'>
          Resources
        </Typography>
      </Box>
      {GUIDE_LINKS.map((g) => (
        <a key={g.text} href={g.href} target='blank' rel='noopener noreferrer'>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography color='black' variant='body2'>
              {g.text}
            </Typography>
          </Box>
        </a>
      ))}
    </Box>
  );
}
